
export default class VideoFileToStream {
  constructor(fileOrBlob, videoElement){
    this._file = fileOrBlob;
    this._videoElement = videoElement;

    this._init = this._init.bind(this);
    this.play = this.play.bind(this);
    this.close = this.close.bind(this);
    this.getVideoStream = this.getVideoStream.bind(this);

    this._init();
  }

  _init(){
    if (this._file.constructor.name === 'File') {
      console.log('VideoFileToStream() input file');
    } else if (this._file.constructor.name === 'Blob') {
      console.log('VideoFileToStream() input Blob');
    } else return;

    this._videoElement.pause();
    this._videoElement.srcObject = null;
    this._videoElement.src = URL.createObjectURL(this._file);
    this._videoElement.load();
    this._videoElement.pause();
  }

  async play(){
    this._videoElement.start();
  }

  close(){
    this._videoElement.pause();
  }

  getVideoStream (){
    // capture this._videoElement
    // return captured stream
  }
}
